<template>
  <mq-layout mq="smallLaptop+">
    <section class="widget product-look">
      <h3 class="widget-title">Un vistazo a {{ $route.params.productName }}</h3>
      <card type="product-look">
        <h1>+ {{ numberLetter(productLook.totalProductData) }}</h1>
        <!-- numberLetter(productLook.totalProductData) -->
        <h4 v-if="$route.name != 'AMCHAMDR Online'">
          De páginas vistas en el portal
        </h4>
        <!-- <h4 v-else-if="$route.name == 'SaludOnline.com.do'">
          Perfiles médicos y centros registrados
        </h4> -->
        <h4 v-else-if="$route.name == 'AMCHAMDR Online'">
          Miembros registrados
        </h4>
        <!-- <h4 v-else-if="$route.name == 'The Business Register'">
          Negocios y oficinas registradas
        </h4> -->
        <div v-if="$route.name != 'AMCHAMDR Online'">
          <h1>+ {{ numberLetter(productLook.sessions) }}</h1>

          <h4>de sessiones</h4>
        </div>
        <div class="devices">
          <div class="mobile">
            <div class="img-wrapper">
              <img
                src="@/assets/images/devices/mobile.svg"
                alt="Ilustración dispositivos móviles"
              />
            </div>
            <p>{{ productLook.mobilePercentage || 0 }} % sesiones en móviles</p>
          </div>
          <div class="desktop">
            <div class="img-wrapper">
              <img
                src="@/assets/images/devices/desktop.svg"
                alt="Ilustración dispositivos de sobremesa"
              />
            </div>
            <p>{{ productLook.desktopPercentage || 0 }}% sesiones en desktop</p>
          </div>
        </div>
        <p>Últimos 12 meses</p>
      </card>
    </section>
  </mq-layout>
</template>
<script>
export default {
  name: "product-look",
  props: {
    productLook: Object
  },
  data() {
    return {
      productName: "PaginasAmarillas.com.do"
    };
  },
  methods: {
    numberLetter(value) {
      let suffixes = [
        "U",
        "D",
        "C",
        "K",
        "K",
        "K",
        "M",
        "M",
        "M",
        "B",
        "B",
        "B",
        "T",
        "T",
        "T"
      ];

      let stringValue = value ? value.toString() : "";
      let valueLength = stringValue.length;
      let suffix = suffixes[valueLength - 1];

      const BASEDIVISOR = 3;
      let startindex = 0;
      let characterToTake = valueLength % BASEDIVISOR;
      characterToTake = characterToTake == 0 ? BASEDIVISOR : characterToTake;

      if (valueLength > BASEDIVISOR) {
        let wholePart = stringValue.substr(startindex, characterToTake);
        let decimalPart = stringValue.substr(
          startindex + characterToTake,
          BASEDIVISOR
        );

        let firstDecimal = decimalPart.substr(startindex, 1);

        let wholeNumber =
          firstDecimal != "0"
            ? wholePart + "." + decimalPart.substr(startindex, 1) + suffix
            : wholePart + suffix;

        return wholeNumber;
      }

      return stringValue;
    }
  }
};
</script>
<style lang="scss" scoped>
.card-product-look {
  background-color: #f7fdff;
  text-align: center;
  h1 {
    margin-bottom: 0px;
    color: $highlight-color;
    font-weight: $font-bold;
    font-size: 3rem;
  }
  h4 {
    margin-bottom: 20px;
  }
  .devices {
    margin-top: 30px;
    padding: 20px 0px;
    display: flex;
    border-top: $separator;
    justify-content: center;
    .img-wrapper {
      height: 90px;
      display: flex;
      justify-content: center;
      align-items: center;
      margin-bottom: 10px;
    }
    .mobile {
      padding: 0px 10px;
      img {
        width: 30px;
        align-self: flex-end;
      }
    }
    .desktop {
      padding: 0px 10px;
      img {
        width: 110px;
        align-self: flex-end;
      }
    }
  }
}
@include respond-above(sm) {
  .card-product-look {
    .devices {
      .mobile {
        img {
          width: 40px;
        }
      }
      .desktop {
        img {
          width: 130px;
        }
      }
    }
  }
}
</style>
